import { styled } from "@mui/material";
import { ReactElement } from "react";
import { RefCallBack } from "react-hook-form";

import { palette } from "~frontend/theme";

import Select, {
  MultiSelect,
  MultiSelectProps,
  SelectProps,
} from "./forms/FormSelect";

export const secondaryDropdownStyle = {
  "& .MuiInputBase-root": {
    fontSize: "12px",
    padding: "6px 0 2px",
    "::before": {
      borderBottom: `1px solid ${palette.midGray}`,
    },
  },

  "& .MuiInputBase-input": {
    padding: "4px 0 0",
  },

  // icon
  "& .MuiSelect-icon": {
    top: "unset",
  },

  // underline
  "& :hover:not(.Mui-disabled, .Mui-error):before": {
    borderBottom: `2px solid ${palette.darkGray}`,
  },
  "& .Mui-focused::after": {
    borderBottom: `2px solid ${palette.darkGray}`,
  },

  // label
  "& .MuiFormLabel-root": {
    fontSize: "14px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: palette.darkGray,
  },
};

const StyledSelect = styled(Select)(secondaryDropdownStyle);

export function SecondaryDropdown(
  props: SelectProps & {
    helperText?: string;
    inputRef?: RefCallBack;
  }
): ReactElement {
  return <StyledSelect {...props} variant="underlined" />;
}

const StyledMultiSelect = styled(MultiSelect)(secondaryDropdownStyle);

export function SecondaryMultiSelect(
  props: MultiSelectProps & {
    helperText?: string;
    inputRef?: RefCallBack;
  }
): ReactElement {
  return <StyledMultiSelect {...props} variant="underlined" />;
}
